import { useWatch } from "react-hook-form";

const useFilterCount = (fieldName: string) => {
  const v = useWatch({ name: fieldName });
  return v ? v.length : 0;
};

export default useFilterCount;
